module.exports = __webpack_public_path__ + "img/vespa_145.d740b20e.png";